export const TEST_ID = 'logoutText';
